export default function ThousandSeperator(input: string) {
    const initial = parseFloat(input).toFixed(2);
    const toNumber = Number(initial).toLocaleString(undefined, {minimumFractionDigits: 2});
    return (
        <>
            {toNumber}
        </>
    )
}